import { FileStack, History, PieChart, UserRound, type LucideIcon } from 'lucide-react';
import type { MessageKey } from '../i18n';

export interface NavItem {
  to: string;
  label: MessageKey;
  icon: LucideIcon;
  /** Which paths highlight this item (sub-flows belong to their section). */
  match: (pathname: string) => boolean;
}

/**
 * The three main sections after login (2026-10 redesign) — fixed; pages of phase 2 depend on these paths.
 * Dit kwartaal also covers the question cards and a return's workplace; Documenten covers transactions.
 */
export const MAIN_NAV: NavItem[] = [
  { to: '/', label: 'nav.thisQuarter', icon: PieChart, match: (p) => p === '/' || p.startsWith('/vragen') || p.startsWith('/aangiftes/') },
  { to: '/documenten', label: 'nav.files', icon: FileStack, match: (p) => p.startsWith('/documenten') || p.startsWith('/transacties') },
  { to: '/historie', label: 'nav.history', icon: History, match: (p) => p.startsWith('/historie') },
];

/** Phones: the same three plus "Account" (= settings) as a bottom tab bar. */
export const MOBILE_TABS: NavItem[] = [
  ...MAIN_NAV,
  { to: '/instellingen', label: 'nav.me', icon: UserRound, match: (p) => p.startsWith('/instellingen') || p.startsWith('/bedrijven') || p.startsWith('/logboek') },
];

export const HELP_URL = 'https://btwkwartier.nl/hulp';
/** Public pages linked from the landing page footer. */
export const SITE_URL = 'https://btwkwartier.nl';
